const getValueFromObj = (objstring: string, obj: any) => {
  try {
    return objstring.split('.').reduce((o: string, i: any) => o[i], obj)
  } catch (error) {
    return null
  }
}

export default getValueFromObj
